module.exports = __webpack_public_path__ + "img/banner-01.bbc1bcb9.jpg";